import React, { useState, useEffect } from "react";
import food from "../assets/images/restaurants/1.png";
import cancel from "../assets/images/navbar/cancel.png";
import share from "../assets/images/order/share.png";
import frame from "../assets/images/order/Frame.png";
import add from "../assets/images/restaurants/add.png";
import minus from "../assets/images/restaurants/minus.png";

type AddOnesProps = {
  isOpen: boolean;
  onClose: () => void;
  count?: number;
  onOrderNow?: () => void;
};

const AddOnes: React.FC<AddOnesProps> = ({ isOpen, onClose, count = 1, onOrderNow }) => {
  const [localCount, setLocalCount] = useState(count);

  useEffect(() => {
    setLocalCount(count);
  }, [count]);

  const handleIncrement = () => {
    setLocalCount((prev) => prev + 1);
  };

  const handleDecrement = () => {
    if (localCount > 1) {
      setLocalCount((prev) => prev - 1);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[1001]"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center z-[1002] pointer-events-none">
        <div
          className="w-[545px] p-6 rounded-[24px] bg-white pointer-events-auto"
          style={{
            boxShadow: "-23px 23px 72px 0 rgba(0, 0, 0, 0.15)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Content */}
          <div>
            {/* image section  */}
            <div className="relative mb-[16px]">
              <img
                src={food}
                alt="Food"
                className="h-[192px] w-full object-cover rounded-[16px]"
              />
              <div
                className="h-[32px] w-[32px] absolute top-4 right-4 bg-white rounded-full p-[7px] cursor-pointer"
                onClick={onClose}
              >
                <img
                  src={cancel}
                  alt="Cancel"
                  className="h-[18px] w-[18px] cursor-pointer"
                  onClick={onClose}
                />
              </div>
            </div>

            <div className="flex items-center justify-between mb-[16px]">
              <p className="text-[#050505] text-center font-Urbanist text-[20px] font-medium leading-[160%]">
                Garlic Noodles
              </p>
              <img src={share} alt="Share" className="h-[24px] w-[24px]" />
            </div>

            {/* options sections */}
            <div className="border rounded-[16px] p-[12px]">
              <div className="pb-[12px] border-b-2">
                <h5 className="text-[#050505] text-left font-Urbanist text-[16px] font-medium leading-[160%]">
                  Customize
                </h5>
                <p className="text-[#6A6A6A] text-left font-Urbanist text-[14px] font-medium leading-[140%]">
                  Required - Select any 1 Option
                </p>
              </div>
              <div className="mt-[12px]">
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-[8px]">
                    <img
                      src={frame}
                      alt="frame"
                      className="h-[14px] w-[14px]"
                    />
                    <p className="text-[#050505] text-center font-Urbanist text-[16px] font-medium leading-[160%]">
                      Option 1
                    </p>
                  </div>

                  <input type="radio" />
                </div>
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-[8px]">
                    <img
                      src={frame}
                      alt="frame"
                      className="h-[14px] w-[14px]"
                    />
                    <p className="text-[#050505] text-center font-Urbanist text-[16px] font-medium leading-[160%]">
                      Option 2
                    </p>
                  </div>

                  <input type="radio" />
                </div>
              </div>
            </div>

            {/* add on section */}
            <div className="border rounded-[16px] p-[12px] mt-[16px]">
              <div className="pb-[12px] border-b-2">
                <h5 className="text-[#050505] text-left font-Urbanist text-[16px] font-medium leading-[160%]">
                  Add On
                </h5>
                <p className="text-[#6A6A6A] text-left font-Urbanist text-[14px] font-medium leading-[140%]">
                  Select up to 5 options
                </p>
              </div>
              <div className="mt-[12px]">
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-[8px]">
                    <img
                      src={frame}
                      alt="frame"
                      className="h-[14px] w-[14px]"
                    />
                    <p className="text-[#050505] text-center font-Urbanist text-[16px] font-medium leading-[160%]">
                      Coke [250 ml]
                    </p>
                  </div>

                  <input type="checkbox" />
                </div>
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-[8px]">
                    <img
                      src={frame}
                      alt="frame"
                      className="h-[14px] w-[14px]"
                    />
                    <p className="text-[#050505] text-center font-Urbanist text-[16px] font-medium leading-[160%]">
                      Fanta [250 ml]
                    </p>
                  </div>

                  <input type="checkbox" />
                </div>
              </div>
            </div>

            <div className="h-[1px] w-full bg-[#E9E9E9] my-[16px]"></div>

            <div className="flex items-center gap-2">
              <div className="flex items-center gap-1 bg-[#F5F5F5] p-[7px] rounded-[12px]">
                <div
                  className="w-[16px] h-[16px] flex items-center justify-center cursor-pointer"
                  onClick={handleDecrement}
                >
                  <img src={minus} alt="minus" className="h-[16px] w-[16px]" />
                </div>
                <span className="text-[#FF8A00] font-Urbanist text-[18px] font-semibold text-center rounded-[10px] px-[15px] py-[6px]">
                  {localCount}
                </span>
                <div
                  className="w-[16px] h-[16px] flex items-center justify-center cursor-pointer"
                  onClick={handleIncrement}
                >
                  <img src={add} alt="add" className="h-[16px] w-[16px]" />
                </div>
              </div>
              <div 
                className="w-[385px] flex justify-center items-center py-[12px] pl-[24px] pr-[12px] bg-[#FF8A00] rounded-[12px] cursor-pointer"
                onClick={onOrderNow}
              >
                <p className="text-white text-center font-Urbanist text-[20px] font-semibold leading-[140%]">
                  Order Now
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOnes;
